export default __webpack_public_path__ + "static/media/editBlackIcon.a7056ec4.svg";